<!--
 * @Author: Tahiti
 * @Date: 2025-10-21 15:03:16
 * @LastEditors: Tahiti
 * @LastEditTime: 2025-12-26 23:10:35
 * @Description: 
 * @FilePath: /weryai-web/components/Tool/ModelSelect.vue
-->
<template>
    <div>
        <label v-if="!hideLabel" class="block text-white text-sm mb-[10px]">
            {{ t('tools.model') }}
        </label>
        <el-select
            v-model="model"
            :style="style_class"
            class="w-full h-14 bg-tool-default-black rounded-[10px] border  border-white/[0.06] hover:border-white/30"
            :popper-class="`${popper_style} select-popper`"
            :fit-input-width="true"
            :show-arrow="false"
            :placeholder="t('tools.describeModel')"
            :aria-label="t('tools.model')"
            :placement="placement"
        >
            <template #label>
                <div class="flex items-center gap-2">
                    <img
                        v-if="currentModel?.thumbnail"
                        :src="currentModel?.thumbnail"
                        alt="icon"
                        class="w-8 h-8 object-cover"
                    />
                    <div class="text-sm font-medium flex flex-col gap-0.5">
                        <span
                            class="text-f-text text-white flex items-center gap-1 text-sm font-normal"
                            >{{ currentModel?.title }}</span
                        >
                        <span class="text-tool-text-default text-xs font-normal">{{
                            currentModel?.desc
                        }}</span>
                    </div>
                </div>
            </template>

            <el-option
                v-for="item in props.model_list"
                :key="item.model_key"
                :label="item.model_key"
                :value="item.model_key"
            >
                <div
                    class="flex items-center group gap-2 h-full overflow-hidden whitespace-normal"
                >
                    <img
                        :src="
                            item?.model_key === model
                                ? checkedIcon
                                : notCheckedIcon
                        "
                        alt="checked"
                        class="w-5 h-5 object-cover"
                        loading="lazy"
                    />
                    <img
                        v-if="item?.thumbnail"
                        :src="item?.thumbnail"
                        alt="icon"
                        class="w-8 h-8 object-cover"
                        loading="lazy"
                    />

                    <div class="text-sm font-medium flex flex-col gap-0.5">
                        <span
                            class="text-white flex items-center gap-1 text-sm font-semibold group-hover:opacity-60 transition-all duration-300"
                            >{{ item?.title }}</span
                        >
                        <span
                            class="text-not-active text-xs font-medium line-clamp-1 group-hover:opacity-60 transition-all duration-300"
                            >{{ item?.desc }}</span
                        >
                    </div>
                </div>
            </el-option>
        </el-select>
    </div>
</template>
<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { useI18n } from '~/composables/useI18n'

const props = withDefaults(
    defineProps<{
        type: string
        model_list: Array<any>
        hideLabel?: boolean
        style_class?: string
        popper_style?: string
        placement?: 'top' | 'bottom' | 'top-start' | 'top-end' | 'bottom-start' | 'bottom-end'
    }>(),
    {
        type: 'text_to_image',
        model_list: () => [],
        hideLabel: false,
        style_class: '',
        popper_style: '',
        placement: 'bottom',
    }
)
const { t, locale } = useI18n()

const checkedIcon =
    'https://static.weryai.com/growth/image/4ebae3f3edb8f4f52281d018c7816648.webp'
const notCheckedIcon =
    'https://static.weryai.com/growth/image/bd6f71cdf35a64773b80d7a5a9930322.webp'

const model = defineModel('model', {
    type: String,
    default: '',
})

onMounted(() => {})

const currentModel = computed(() => {
    return props.model_list.find(item => item.model_key === model.value)
})
</script>
<style scoped lang="less">
:deep(.el-select__wrapper) {
    height: 100%;
    background-color: transparent;
    border: none;
    box-shadow: none;
    &:hover {
        border: none;
        box-shadow: none;
    }
    &:focus-visible {
        border: none;
    }
}
</style>

<style lang="less">
.select-popper {
    background-color: #1C1C20 !important;
    border: none !important;
    box-shadow: none !important;
    .el-select-dropdown__item {
        height: 60px !important;
        margin-bottom: 10px !important;
        margin: 0 10px !important;
        border-radius: 10px !important;
        &.is-hovering {
            background-color: transparent !important;
        }
        &.is-selected {
            background-color: transparent !important;
        }
    }
}

[type='text']:focus,
[type='email']:focus,
[type='password']:focus {
    outline: none !important;
    border: none !important;
    box-shadow: none !important;
    color: #fff !important;
}
</style>
